import { render } from "./DownloadDialog.vue?vue&type=template&id=56fbd294"
import script from "./DownloadDialog.vue?vue&type=script&lang=js"
export * from "./DownloadDialog.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__